import React from "react";

import Navbar from "../Components/Navbar";

import Footer from "../Components/Footer";
import Home from "./Home";
import Enter_prompt from "./Enter_prompt";
import SelectNFTImages from "./SelectNFTImages";
import Detail_NFT from "./Detail_NFT";
import MoreStyle from "./MoreStyle";

import { BrowserRouter, Routes, Route, Switch } from "react-router-dom";
import GenerateAiArt from "./GenerateAiArt";
import JsonGenarator from "./JsonGenarator";
import GetNFTS from "./GetNFts";

class Layout extends React.Component {
  state = {
    mode: false,
  };

  handleHomePageMode = (event) => {
    this.setState({ mode: !this.state.mode });
  };

  render() {
    return (
      <div className={!this.state.mode ? "" : "foundation-white-theme"}>
        <div className="background">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <header className=" fixed-top foundation-header ">
          <Navbar modeChange={this.handleHomePageMode} />
        </header>

        <section className="">
       
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<JsonGenarator />} />
              <Route path="/getnfts" element={<GetNFTS />} />
              <Route path="/generateaiart" element={<GenerateAiArt />} />
            </Routes>
          </BrowserRouter>

          {/* <Home/>  */}?

          {/*  <Enter_prompt/>
          <SelectNFTImages/>
          <Detail_NFT/>
          <MoreStyle/> */}

          {/* <GenerateAiArt/> */}
        </section>
        <Footer />
      </div>
    );
  }
}

export default Layout;
